<template>
  <div :class="['annotation', { 'user-select-disabled': clearSelection || (on && selection.start) }]">
    <div class="body">
      <slot></slot>
    </div>
    <transition name="fade-up">
      <annotation-controls :annotation="annotation" v-if="showControls" ref="controls" @save="save()" @close="resetSelection()" @controlsMounted="positionControls" :on="on" />
    </transition>
  </div>
</template>

<script>

  import AnnotationControls from './controls'
  import AnnotationSwatch from './swatch'
  import AnnotationsStore from '@/store/models/annotations'

  const emptySelection = () => {
    return { start: null, end: null, highlighting: false, type: null }
  }

  export default {
    name: 'annotator',
    props: {
      on: Boolean,
      readOnly: {
        type: Boolean,
        default: false
      },
      config: Object,
      inject: Array
    },
    components: { AnnotationControls },
    data () {
      return {
        selectionReady: true, //shitty
        selection: emptySelection(),
        showControls: true,
        tapper: false,
        controlsPositionTo: null,
        annotation: null,
        clearSelection: false,
        getWords (start, end) {
          [start, end] = [start, end].sort();
          return $((_.map(_.range(start, end+1), word => $(`.word_${word}`,this.$el))));
        }
      }
    },
    methods: {
      resetSelection () {
        this.selection = emptySelection()
        this.selectionReady = false
        this.showControls = false
      },
      add (annotations) {
        _.map(_.flatten([annotations]), (annotation) => {
          const isNew = !annotation.id
          const words = this.getWords(annotation.startWord, annotation.endWord);
          words.each(function() {
            $(this)
              .data("ssAnnotation", annotation.id)
              .addClass("is-annotated")
              .toggleClass("has-note", !!(annotation.note != null ? annotation.note.length : undefined));
            if (annotation.color) {
              return $(this)
                .removeClass((index, css) => (css.match(/(^|\s)color-\S+/g) || []).join(' '))
                .addClass(`color-${annotation.color.id}`);
            }
          });
        })
      },
      remove (annotations) {
        _.map(_.flatten([annotations]), (annotation) => {
          const words = this.getWords(annotation.startWord, annotation.endWord);
          words.each((index, element) => {
            $(element)
              .data("ssAnnotation", null)
              .removeClass(`is-annotated has-note color-${(annotation.color != null ? annotation.color.id : undefined)}`)
          })
        });
      },
      injectFromStore () {
        this.add(this.inject)
      },
      controlSelection (positionTo) {
        this.showControls = false
        this.controlsPositionTo = null
        this.$nextTick(() => {
          this.showControls = true
          this.controlsPositionTo = positionTo
        })
      },
      positionControls () {
        if(!this.controlsPositionTo) {
          return
        }
        $(this.$refs.controls.$el).position({
          my: "center bottom",
          at: "center top",
          of: $(`[data-word=${this.controlsPositionTo}]`, this.$el),
          collision: "fit flip",
          within: this.$el,
          using (coords, info) {
            if(info.vertical=='top') {
              coords.top += 20
            }
            $(info.element.element)
              .css(coords)
              .toggleClass("flipped", info.vertical=='top')
          }
        })
      }
    },
    watch: {
      'selection': {
        handler (selection) {
          let start = selection.start
          let end = selection.end || selection.start
          $(".selected-word", this.$el).removeClass("selected-word")
          this.getWords(start, end).each(function() { return $(this).addClass("selected-word"); });
        },
        deep: true
      },
      selectionReady (ready) {
        if(ready) {
          this.selection.end = this.selection.end || this.selection.start
          this.annotation = this.$store.createInstance('annotations', {
            startWord: this.selection.start,
            endWord: this.selection.end,
            text: ((_.map(this.getWords(this.selection.start, this.selection.end), word => $(word).text())).join("")).replace(/\s/g, " "),
            overlap: $(".is-annotated.selected-word", this.$el).length
          })
          _.assign(this.annotation, this.config)
          this.controlSelection(this.annotation.endWord)
        }
      },
      on (on) {
        if ( document.selection ) {
          document.selection.empty()
        } else if ( window.getSelection ) {
          window.getSelection().removeAllRanges()
        }
      }
    },
    created () {
      AnnotationsStore.on("DS.afterInject", (store, annotations) => {
        this.add(annotations)
      })
      AnnotationsStore.on("DS.afterEject", (store, annotations) => {
        this.remove(annotations)
      })
    },
    destroyed () {
      AnnotationsStore.off("DS.afterInject")
      AnnotationsStore.off("DS.afterEject")
    },
    mounted () {

      const $el = $(this.$el)
      const $words = $(".word", $el)
      const wordSelector = ".word:not(.is-annotated)"

      // Inject them
      this.injectFromStore()
      this.selectionReady = false
      this.showControls = false

      // Give all words a tabindex by default
      // a11y -- bring in later
      // $words.attr("tabindex", "0")

      // Setup event bindings
      $el
        // Allow text to be "selected"
        .on("mousedown", wordSelector, (e) => {
          if(!this.on) { return }
          e.stopPropagation()
          const word = $(e.currentTarget).data("word")
          if(e.type == "mousedown") {
            this.resetSelection()
            this.selection.start = word
            $el.on("mouseenter.annotationSelection", wordSelector, (e) => {
              this.selection.end = $(e.currentTarget).data("word")
            })
            $(document).one("mouseup", (e) => {
              this.selectionReady = true
              $el.off("mouseenter.annotationSelection")
            })
          }
        })
        // Touch support
        .on("touchstart", wordSelector, (e) => {
          this.tapper = true
          if(this.selectionReady) {
            this.resetSelection()
          }
        })
        .on("touchmove", wordSelector, (e) => {
          this.tapper = false
        })
        .on("touchend", wordSelector, (e) => {
          e.preventDefault()
          if(!this.on || !this.tapper) { return }
          const word = $(e.currentTarget).data("word")
          if(!this.selection.start) {
            this.resetSelection()
            this.selection.start = word
          } else {
            this.selection.end = word
            this.selectionReady = true
          }
        })
        // Open control for annotation on click
        .on("click", ".is-annotated", (e) => {
          // if(!this.on) { return }
          const annotationId = $(e.currentTarget).data("ssAnnotation");
          this.annotation = this.$store.get('annotations', annotationId)
          this.controlSelection($(e.currentTarget).data("word"))
        })
        // Reset annotation when "esc" key is pressed
        .on("keyup", (e) => {
          if(e.keyCode === 27) {
            e.stopPropagation()
            this.resetSelection()
          }
        })
        // Give the annotations a "hover state"
        .on("mouseenter mouseleave", ".is-annotated", (e) => {
          if(!this.on) { return }
          const annotation = this.$store.get('annotations', $(e.currentTarget).data("ssAnnotation"))
          if(annotation) {
            this.getWords(annotation.startWord, annotation.endWord).each(function() {
              $(this).toggleClass("hovered-word", e.type==="mouseenter")
            });
          }
        })

    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  /deep/ {
    .word {
      text-indent: 0; display: inline-block; outline:none;
    }
    .selected-word {
      background-color: #b4d6ff; transition:none;
    }
    .is-annotated {
      position:relative; background-color: rgba(yellow, .5); cursor:pointer; transition:background .15s ease-in-out;
      &.hovered-word {
        background-color:rgba(yellow, .8);
      }
      &.has-note:before {
        @include position(absolute, null 0 0 0);
        height:.3rem; content:''; background-color:yellow;
      }
      @each $color in $annotationColors {
        &.color-#{index($annotationColors, $color)} {
          background-color: rgba($color, .5);
          &.hovered-word {
            background-color: rgba($color, .8);
          }
          &.has-note:before {
            background-color:$color;
          }
        }
      }
    }
  }

  .user-select-disabled {
    user-select: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Annotator/index.vue